/**
 * @deprecated The legacy 'WarehousesStore' is in use. Please migrate to RTK Query hooks like `useGetV4WarehousesQuery`. Refer to CONTRIBUTING.md for more information.
 */
export default class WarehousesStore {
  constructor() {
    console.warn(
      "Deprecation Warning: The legacy 'WarehousesStore' is in use. Please migrate to RTK Query as outlined in CONTRIBUTING.md."
    );
  }

  /**
   * @deprecated This function is incorrect and returns the warehouse ID instead of its name.
   * Please use `useGetV4WarehousesQuery` from `randmar-api-client` to fetch warehouses and find the correct name.
   */
  public getWarehouseNameFromCode(warehouseId?: string) {
    if (!warehouseId) return "B/O";
    return warehouseId;
  }
}
